import { Document } from '@talon/web/lib/api';
import { IconProps } from 'grommet-icons';
import React from 'react';
import { toast } from 'react-toastify';
import { useProjectStore } from '../../../context';
import { documentConfig } from './DocumentUploadModal';

export type DocumentLinkProps = { doc: Document; size?: IconProps['size']; color?: IconProps['color'] };

export const DocumentLink = ({ doc, size = 'medium', color }: DocumentLinkProps) => {
  /** Context **/
  const projectStore = useProjectStore();

  /** Methods **/
  const getSignedDownloadLink = async (id: string) => {
    if (!id) return;
    const link = await projectStore.getSignedDownloadLink(id);
    if (link) {
      window.open(link, '_blank');
    } else {
      toast.error('Error getting download link');
    }
  };

  /** Render **/
  const icon = React.cloneElement(documentConfig[doc.type].icon, {
    a11yTitle: doc.type,
    onClick: () => getSignedDownloadLink(doc.id),
    size,
    color,
    style: { cursor: 'pointer' },
  });

  return icon;
};
